import { Field } from 'formik';
import { rgba } from 'polished';
import styled from 'styled-components';

import { tokens } from '../../theme/tokens';

type PageTitleFieldTint = 'light' | 'dark';

export const PageTitleField = styled(Field)<{ tint: PageTitleFieldTint }>`
	width: 100%;
	display: block;
	overflow: hidden;
	font-size: 22px;
	line-height: 1.25;
	font-weight: 700;
	margin: 0;
	padding: 0;
	color: ${tokens.text.primary};
	background-color: transparent;

	${(props) =>
		props.tint === 'light' &&
		`
		color: ${props.theme.colors.white};
		::placeholder {
			color: ${rgba(props.theme.colors.white, 0.6)};
		}
	`}

	:disabled {
		background-color: transparent;
	}
`;
